import { RequiredSKU } from '../../../../../core';

export const requiredSKU = {
    searchText: '',
    sort: false,
    dialogHability: true,
    filter: false,
    checkbox: false,
    expandable: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: RequiredSKU) => element.skuCode
      },
      {
        title: 'Descripci\u00F3n',
        name: 'description',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: RequiredSKU) => element.description
      },
      {
        title: 'Cantidad Requerida',
        name: 'requiredQuantity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: RequiredSKU) => element.requiredQuantity
      }
    ]
  };
